export default "__VITE_ASSET__ef2d6414__"